import type { AccountContext, TransactionRow, TransactionSummary } from '../types';

export const MOCK_ACCOUNT_ID = '9222722';

export const MOCK_ACCOUNT_CONTEXT: AccountContext = {
  accountId: MOCK_ACCOUNT_ID,
  artistName: 'Demo Artist',
  firstname: 'Alex',
  lastname: 'Rivera',
  accountNumber: '1000123456',
  accountStatus: 'Open',
};

export const MOCK_TRANSACTIONS: TransactionRow[] = [
  {
    id: '12542562',
    summary: 'SANDBOX | Sandbox Funding',
    createdAt: '2026-01-21T14:51:05.667Z',
    name: 'SANDBOX',
    routingNumber: null,
    accountType: null,
    type: 'ReceivedAch',
    amount: 20000,
    direction: 'Credit',
  },
  {
    id: '12542563',
    summary: 'Fee for transaction #12542562',
    createdAt: '2026-01-21T14:51:05.667Z',
    name: null,
    routingNumber: null,
    accountType: null,
    type: 'Fee',
    amount: 0.05,
    direction: 'Debit',
  },
  {
    id: '12716037',
    summary: 'Testing Test | test payment',
    createdAt: '2026-01-27T05:40:47.040Z',
    name: 'Testing Test',
    routingNumber: '812345678',
    accountType: 'Checking',
    type: 'Book',
    amount: 10,
    direction: 'Debit',
  },
  {
    id: '12717390',
    summary: 'Testing Test | test payment staging',
    createdAt: '2026-01-27T06:21:03.926Z',
    name: 'Testing Test',
    routingNumber: '812345678',
    accountType: 'Checking',
    type: 'Book',
    amount: 8,
    direction: 'Debit',
  },
  {
    id: '12717391',
    summary: 'Testing Test | test payment staging',
    createdAt: '2026-01-27T06:22:19.125Z',
    name: 'Testing Test',
    routingNumber: '812345678',
    accountType: 'Checking',
    type: 'Book',
    amount: 0.1,
    direction: 'Debit',
  },
  {
    id: '12718213',
    summary: 'Testing Test | Payout TXN-20260127-00001',
    createdAt: '2026-01-27T08:19:02.270Z',
    name: 'Testing Test',
    routingNumber: '812345678',
    accountType: 'Checking',
    type: 'Book',
    amount: 100,
    direction: 'Debit',
  },
  {
    id: '12718814',
    summary: 'Testing Test | Test payout - small amount',
    createdAt: '2026-01-27T08:50:03.461Z',
    name: 'Testing Test',
    routingNumber: '812345678',
    accountType: 'Checking',
    type: 'Book',
    amount: 0.5,
    direction: 'Debit',
  },
  {
    id: '12718816',
    summary: 'Madhuri G | Test payout - small amount',
    createdAt: '2026-01-27T08:50:04.754Z',
    name: 'Madhuri G',
    routingNumber: '812345678',
    accountType: 'Checking',
    type: 'Book',
    amount: 4.25,
    direction: 'Debit',
  },
  {
    id: '12718817',
    summary: 'Mahesh Babu Uppala | Test payout - small amount',
    createdAt: '2026-01-27T08:50:05.598Z',
    name: 'Mahesh Babu Uppala',
    routingNumber: '812345678',
    accountType: 'Checking',
    type: 'Book',
    amount: 2.25,
    direction: 'Debit',
  },
  {
    id: '12721795',
    summary: 'Mahesh Babu Uppala | Payout TXN-20260127-00009',
    createdAt: '2026-01-27T12:24:03.114Z',
    name: 'Mahesh Babu Uppala',
    routingNumber: '812345678',
    accountType: 'Checking',
    type: 'Book',
    amount: 0.5,
    direction: 'Debit',
  },
  {
    id: '12721796',
    summary: 'Madhuri G | Payout TXN-20260127-00010',
    createdAt: '2026-01-27T12:24:04.287Z',
    name: 'Madhuri G',
    routingNumber: '812345678',
    accountType: 'Checking',
    type: 'Book',
    amount: 1,
    direction: 'Debit',
  },
  {
    id: '13000001',
    summary: 'SANDBOX | April funding',
    createdAt: '2026-04-12T10:00:00.000Z',
    name: 'SANDBOX',
    routingNumber: null,
    accountType: null,
    type: 'ReceivedAch',
    amount: 5000,
    direction: 'Credit',
  },
  {
    id: '13000002',
    summary: 'Studio Rent | April payment',
    createdAt: '2026-04-18T14:30:00.000Z',
    name: 'Studio Rent Co',
    routingNumber: '812345678',
    accountType: 'Checking',
    type: 'Book',
    amount: 850,
    direction: 'Debit',
  },
  {
    id: '13000003',
    summary: 'SANDBOX | May funding',
    createdAt: '2026-05-05T09:15:00.000Z',
    name: 'SANDBOX',
    routingNumber: null,
    accountType: null,
    type: 'ReceivedAch',
    amount: 3500,
    direction: 'Credit',
  },
  {
    id: '13000004',
    summary: 'Testing Test | May payout batch',
    createdAt: '2026-05-20T16:45:00.000Z',
    name: 'Testing Test',
    routingNumber: '812345678',
    accountType: 'Checking',
    type: 'Book',
    amount: 420,
    direction: 'Debit',
  },
  {
    id: '13000005',
    summary: 'Fee for transaction #13000003',
    createdAt: '2026-05-05T09:15:00.000Z',
    name: null,
    routingNumber: null,
    accountType: null,
    type: 'Fee',
    amount: 0.05,
    direction: 'Debit',
  },
];

export const MOCK_SUMMARY: TransactionSummary = {
  overview: {
    netChange: 19873.35,
    totalTransactions: 11,
    lastTransactionDate: '2026-01-27T12:24:04.287Z',
    totalCredits: 20000,
    totalDebits: 126.65,
  },
  creditsBreakdown: {
    byType: { ReceivedAch: 20000 },
  },
  debitsBreakdown: {
    byType: { Book: 126.6, Fee: 0.05 },
  },
  insights: {
    primaryIncomeSource: 'ReceivedAch',
    primaryExpenseType: 'Book',
    spendingRatio: 0.0063,
    netFlow: 'positive',
  },
};
